import React from 'react'

function Link(props) {
    const { action, children, className, ...rest } = props
    const classNames = ['text-primary-700 cursor-pointer hover:underline rounded-md outline-none focus:outline-none focus:shadow-outline', className].join(' ');
    return (
        <button type="button" tabIndex="0" onClick={action} className={classNames} {...rest}>{children}</button>
    )
}

export default Link
